import createPalette from '@mui/material/styles/createPalette.js';

import {THEME_VARIANTS} from './Constants.js';

const defaultDarkPalette = createPalette({mode: THEME_VARIANTS.DARK});
// Dark Theme Variant
export const DARK = {
  primary: {
    main: '#00CBE5',
    dark: '#098D9E',
    light: '#76DFF2',
  },
  secondary: {
    main: '#D9D9D9',
    dark: '#9E9E9E',
    light: '#F2F2F2',
  },
  tertiary: defaultDarkPalette.augmentColor({
    color: {
      main: '#FFD700',
      dark: '#B09A31',
      light: '#FBE56D',
    },
    name: 'tertiary',
  }),
  success: {
    main: '#0CE277',
    dark: '#489E5C',
    light: '#86E9AA',
  },
  background: {
    paper: '#161822',
    default: '#161822',
  },
  action: {
    active: 'rgba(255,255,255, 0.8)',
  },
};

// Light Theme Variant
const defaultLightPalette = createPalette({mode: THEME_VARIANTS.LIGHT});
export const LIGHT = {
  primary: {
    main: '#009DB1',
    dark: '#017382',
    light: '#4DBAC8',
  },
  secondary: {
    main: '#888888',
    dark: '#616161',
    light: '#C8C8C8',
  },
  tertiary: defaultLightPalette.augmentColor({
    color: {
      main: '#FFD700',
      dark: '#B09A31',
      light: '#FBE56D',
    },
    name: 'tertiary',
  }),
  action: {
    active: 'rgba(0,0,0, 0.8)',
  },
};

export default {LIGHT, DARK};
